import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/prevention")({
  beforeLoad: () => {
    throw redirect({ to: "/effectiveness-prevention" });
  },
});
